import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { ComboBox as AriaComboBox, ComboBoxStateContext, Input as AriaInput, InputContext, LabelContext, useSlottedContext } from "react-aria-components";
import { wrapper } from "./ComboBox.css.js";
import { ListBox } from "./ListBox.js";
import { Popover } from "./Popover.js";
import { Spinner } from "./Spinner.js";
import { FCTextFieldContext } from "./TextFieldContext.js";
import { ChevronButton } from "./shared/ChevronButton.js";
import { ClearButton } from "./shared/ClearButton.js";
import ErrorIcon from "./shared/ErrorIcon.js";
import { InputBuilder } from "./shared/InputBuilder.js";
import { extractInputBuilderProps } from "./shared/inputBuilderHelper.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function RightIcons(t0) {
  const $ = _c(7);
  const {
    isError,
    isOpen,
    loadingState,
    loadingRenderState,
    loadingStartAnimation
  } = t0;
  const selectionState = React.useContext(ComboBoxStateContext);
  if (isError && !isOpen || isError && isOpen && selectionState?.selectedKey == null) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx(ErrorIcon, {});
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== loadingRenderState || $[2] !== loadingStartAnimation || $[3] !== loadingState) {
    t1 = loadingState == null ? null : /*#__PURE__*/_jsx(Spinner, {
      state: loadingState,
      renderState: loadingRenderState,
      startAnimation: loadingStartAnimation,
      size: "s",
      color: "royalBlue"
    });
    $[1] = loadingRenderState;
    $[2] = loadingStartAnimation;
    $[3] = loadingState;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = /*#__PURE__*/_jsx(_Fragment, {
      children: t1
    });
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export function ComboBox(t0) {
  const $ = _c(25);
  const {
    children,
    placeholder,
    title,
    clearButton: t1,
    virtualized: t2,
    ...props
  } = t0;
  const clearButton = t1 === undefined ? false : t1;
  const virtualized = t2 === undefined ? false : t2;
  const ref = React.useRef(null);
  const {
    inputBuilderProps,
    restProps
  } = extractInputBuilderProps(props);
  const labelProps = useSlottedContext(LabelContext);
  const inputProps = useSlottedContext(InputContext);
  const {
    name,
    textFieldProps: t3
  } = React.useContext(FCTextFieldContext);
  let isInvalid;
  let textFieldProps;
  if ($[0] !== t3) {
    ({
      isInvalid,
      ...textFieldProps
    } = t3);
    $[0] = t3;
    $[1] = isInvalid;
    $[2] = textFieldProps;
  } else {
    isInvalid = $[1];
    textFieldProps = $[2];
  }
  const t4 = isInvalid || undefined;
  const t5 = labelProps?.id ?? undefined;
  let t6;
  if ($[3] !== clearButton) {
    t6 = state => /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(RightIcons, {
        ...state
      }, "icon"), /*#__PURE__*/_jsx(ClearButton, {
        clearButton: clearButton
      }, "clear"), /*#__PURE__*/_jsx(ChevronButton, {}, "chevron")]
    });
    $[3] = clearButton;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = inputProps?.id ?? undefined;
  let t8;
  if ($[5] !== placeholder || $[6] !== t7 || $[7] !== title) {
    t8 = /*#__PURE__*/_jsx(AriaInput, {
      id: t7,
      title: title,
      placeholder: placeholder
    });
    $[5] = placeholder;
    $[6] = t7;
    $[7] = title;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== inputBuilderProps || $[10] !== t6 || $[11] !== t8) {
    t9 = /*#__PURE__*/_jsx(InputBuilder, {
      ref: ref,
      ...inputBuilderProps,
      right: t6,
      children: t8
    });
    $[9] = inputBuilderProps;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== children || $[14] !== inputBuilderProps.size || $[15] !== virtualized) {
    t10 = /*#__PURE__*/_jsx(Popover, {
      triggerRef: ref,
      width: "triggerRef",
      children: /*#__PURE__*/_jsx(ListBox, {
        size: inputBuilderProps.size,
        virtualized: virtualized,
        children: children
      })
    });
    $[13] = children;
    $[14] = inputBuilderProps.size;
    $[15] = virtualized;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== name || $[18] !== restProps || $[19] !== t10 || $[20] !== t4 || $[21] !== t5 || $[22] !== t9 || $[23] !== textFieldProps) {
    t11 = /*#__PURE__*/_jsxs(AriaComboBox, {
      name: name,
      ...textFieldProps,
      isInvalid: t4,
      "aria-labelledby": t5,
      menuTrigger: "focus",
      className: wrapper,
      ...restProps,
      children: [t9, t10]
    });
    $[17] = name;
    $[18] = restProps;
    $[19] = t10;
    $[20] = t4;
    $[21] = t5;
    $[22] = t9;
    $[23] = textFieldProps;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
//# sourceMappingURL=ComboBox.js.map